import { render, staticRenderFns } from "./Passed.vue?vue&type=template&id=9234de12&"
import script from "./Passed.vue?vue&type=script&lang=js&"
export * from "./Passed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports